import { Button, Col, Flex, Form, Row, Select, Tooltip, Upload } from "antd";
import React, { FC, useEffect, useState } from "react";
import {
  DeleteOutlined,
  DownloadOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  EyeTwoTone,
  UploadOutlined,
} from "@ant-design/icons";
import { PatientDocumentUploadProps } from "../../props/AddCaseProps";
import ViewUploadReferralDocuments from "./ViewUploadReferralDocuments";

const PatientDocumentUpload: FC<PatientDocumentUploadProps> = React.memo(
  (props) => {
    const [documentName, setDocumentName] = useState("");
    const [newDocumentTypes, setNewDocumentTypes] = useState<Array<any>>(
      props?.documentTypes
    );

    useEffect(() => {
      if (props?.listOfResponseUrl) {
        const filteredDocumentType = props?.documentTypes?.filter(
          (item) =>
            !props?.listOfResponseUrl?.some(
              (urlItem) => urlItem.documentLabelType === item.label
            )
        );

        setNewDocumentTypes(filteredDocumentType);
      }
    }, [props?.listOfResponseUrl, props?.documentTypes]);

    return (
      <>
        <div className="referral-container">

          <ViewUploadReferralDocuments
            uploadFileModal={props?.uploadFileModal}
            setUploadFileModal={props?.setUploadFileModal}
            selectedFile={props?.selectedFile}
            setDocumentType={props?.setDocumentType}
            handleSaveReferral={props?.handleSaveReferral}
            isReferralLoading={props?.isReferralLoading}
            key={props?.selectedFile?.file?.uid || "no-file"}
            handleUploadCapfReferral={props?.handleUploadCapfReferral}
            schemeSelected={props?.schemeSelected}
            documentTypes={props?.documentTypes}
          />
          {/* <DocumentDeficiencyModal
            key={props?.previewDocumentUrl}
            closeDeficiencyModal={props?.closeDeficiencyModal}
            deficiencyModal={props?.deficiencyModal}
            documentUrl={props?.previewDocumentUrl}
            documentName={documentName}
            handleDownloadDocument={props?.handleDownloadDocument}
            isDownloadingDocument={props?.isDownloadingDocument}
            downloadingDocumentUrl={props?.downloadingDocumentUrl}
            deficiencyQuestions={props?.deficiencyQuestions}
            selectedDocument={props?.selectedDocument}
          /> */}
        </div>
      </>
    );
  }
);

export default PatientDocumentUpload;
